import { CodigoEmPecas } from "@/ui/CodigoEmPecas";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { watchChallenge, type Challenge } from "@/data/challenges";
import { Spinner, TopBar } from "@/ui/primitives";

/** Tela do convite, logo depois de criar o desafio. */
export function Invite() {
  const { cid = "" } = useParams();
  const [challenge, setChallenge] = useState<Challenge | null | undefined>(undefined);
  const [copiado, setCopiado] = useState("");

  useEffect(() => watchChallenge(cid, setChallenge), [cid]);

  if (challenge === undefined) return <div className="screen center"><Spinner /></div>;
  if (!challenge) return <div className="screen center"><p>Desafio não encontrado.</p></div>;

  const link = `${location.origin}/convite/${challenge.code}`;
  const texto = `Bora pro desafio "${challenge.name}" no Nhomi!\n${link}`;

  async function compartilhar() {
    if (navigator.share) {
      try { await navigator.share({ title: "Nhomi", text: texto }); return; } catch { /* cancelou */ }
    }
    await copiar(texto, "Convite copiado!");
  }

  async function copiar(valor: string, aviso: string) {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiado(aviso);
      setTimeout(() => setCopiado(""), 2200);
    } catch {
      setCopiado("Não deu pra copiar — selecione o código à mão.");
    }
  }

  return (
    <main className="screen">
      <TopBar title="Convidar" back={`/c/${cid}`} />
      <div className="pad">
        <div className="page-head">
          <h1>{challenge.name}</h1>
          <p>Manda esse código pra galera</p>
        </div>
        <div className="card"><CodigoEmPecas codigo={challenge.code} /></div>
        {copiado ? <p className="note center" role="status">{copiado}</p> : null}
        <button className="btn btn-primary" onClick={compartilhar}>Compartilhar convite</button>
        <button className="btn btn-outline" onClick={() => copiar(challenge.code, "Código copiado!")}>
          Copiar código
        </button>
      </div>
    </main>
  );
}
